import React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Footer from "./footer"

import "../css/layout.css"

const Layout = ({ activePage, children }) => (
  <>
    <Header activePageName={activePage} />
    <main className="container content py-3">{children}</main>
    <Footer />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
